// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3WzD0","Hoverable":"Button_Hoverable__hpyWk"};